import { isProductionRelease } from "@src/config/build";

/**
 * Whether this build is the production release.
 *
 * Used to gate internal-only routes (e.g. `/development/*`) that must never
 * be reachable by end users, even via a direct URL.
 */
export function isProductionEnvironment(): boolean {
  return isProductionRelease;
}
